export const OPERATOR_HIDDEN_COLUMNS = ['position', 'version'];
